/**
 * d16n::legacy
 * d16n::source:PConvertResult.vue
 * d16n::helpers-file
 */

export const packageType = (option: string, isBig: boolean) => {
  switch (option) {
    case 'MG':
      return isBig ? 'bigdose' : 'dose'
    case 'kg':
      return isBig ? 'bigbag' : 'sac'
    default:
      return ''
  }
}
